import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CardComponent from "../../components/card";
import Loader from "../../components/Loader";
import { errorMessage } from '../../components/Toaster';
import { getErrorMessage } from '../../utils/error';
import { getCounts } from './api';
import { ApiResponse, GetCountsData } from './interface';

function Home() {
  const [loading, setLoading] = useState(true);
  const [userCount, setUserCount] = useState<number | null>(null);
  const [companyCount, setCompanyCount] = useState<number | null>(null);

  useEffect(() => {
    const fetchCounts = async () => {
      setLoading(true);
      try {
        const countsData: ApiResponse<GetCountsData> = await getCounts();
        if (countsData.status && countsData.data) {
          setUserCount(countsData.data.total_users);
          setCompanyCount(countsData.data.total_companies);
        } else {
          errorMessage(countsData.message || "Failed to fetch counts.");
        }
      } catch (error) {
        console.error("Error fetching counts:", error);
        const message = getErrorMessage(error);
        errorMessage(message || "Error fetching counts.");
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return (
    <>
      {loading ? (
        <Loader color="primary" size={40} />
      ) : (
        <Box style={{ width: "100%", height: "50%" }}>
          <main className="m-a-20">
            <Grid container className="m-t-20" spacing={2}>
              <Grid size={3}>
                <CardComponent value={userCount || 0} label="Total Users" />
              </Grid>
              <Grid size={3}>
                <CardComponent value={companyCount || 0} label="Total Companies" />
              </Grid>
            </Grid>
          </main>
        </Box>
      )}
    </>
  );
}

export default Home;
